import type EnType from '../en-US/component';

export default {
  'component.securityScheme.formItemName.authorizationType': '認証タイプ',
  'component.securityScheme.apiKeyFormItem.name.label': '名前',
  'component.securityScheme.allowedSecuritySchemes': '使用可能なSecurity Scheme',
  'component.securityScheme.preview.title': 'Security Scheme',
  'component.securityScheme.optional': '認証をオプションにする',
  'component.securityScheme.inheritFrom': '親フォルダーから継承',
  'component.securityScheme.noAuthDesc': '認証は必要ありません',
  'component.securityScheme.useCase.empty-alert':
    'このAPIで参照されているSecurity Schemeは削除されました。このAPIの認証設定を変更してください。',
} satisfies typeof EnType;
